import { parseBooleanValue } from "../../util";
import { IIndexType } from "../model/IndexType";

const IndexTypeParamMapper = (item: IIndexType) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default IndexTypeParamMapper;
